/**
 * Divider — `DESIGN-HANDOVER.md` §5.9. `1px`, `#e6e6e6`, no radius, no shadow.
 * Both orientations are authored.
 */
export function Divider({
  orientation = 'horizontal',
  className,
}: {
  orientation?: 'horizontal' | 'vertical'
  className?: string
}) {
  return (
    <div
      role="separator"
      aria-orientation={orientation}
      className={`bg-border-primary ${
        orientation === 'horizontal' ? 'h-px w-full' : 'h-full w-px'
      }${className ? ` ${className}` : ''}`}
    />
  )
}
